import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { slugify } from "gatsby-frontend";
import { MoreButton } from "./../";

function Buttons({ links, singleColumn, type, color }) {
	const theme = useTheme();
	if (links.length === 0) return <></>;
	let cols_count =
		links.length === 1
			? 1
			: [2, 3].find((maybe_cols) => !(links.length % maybe_cols));
	if (!cols_count) cols_count = 2;
	let col_w = `${100 / cols_count}%`;
	let padd =
		links.length === 1 || singleColumn
			? theme.spacing(0, 0, 2, 0)
			: theme.spacing(0, 1, 2, 1);
	return (
		<Box
			component="nav"
			className={`buttons ${singleColumn ? "single-col" : ""}`}
			sx={(theme) => ({
				display: "flex",
				flexWrap: "wrap",
				marginX:
					type === "link" || links.length === 1 || singleColumn
						? 0
						: theme.spacing(-1),
				marginBottom: theme.spacing(-2),
			})}
		>
			{links.map((l) => (
				<Box
					sx={{ width: col_w, padding: padd }}
					key={slugify(`${l.label}_${l.to}`)}
				>
					<MoreButton
						to={l.to}
						toLabel={l.label}
						variant="contained"
						color={l.color ? l.color : color ? color : "primary"}
						size="large"
						sx={{ width: "100%", height: "100%" }}
						link={type === "link"}
					/>
				</Box>
			))}
		</Box>
	);
}

export default Buttons;
